module.exports = __webpack_public_path__ + "media/reskin-images/icon--mail-675fba84.svg";